import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import * as QuizPhase from '../../../commons/QuizPhase'
import {
  FETCH_QUESTION,
  RECEIVE_CHANGE_STATUS,
  RECEIVE_CHANGE_PARTICIPANT,
  POST_ANSWER
} from '../../actions/questionActions'
import { QuizType } from '../../../commons/EditorStatus'
import { FirestoreRepository } from '../../../commons/repository/FirestoreRepository'
import { NAME, RANK } from '../../../commons/Const'
import { getStorage, setStorage, removeStorage } from '../../../commons/utils'
import Spinner from '../../components/atoms/Spinner/Spinner'
import ModalError from '../../components/molecules/ErrorModal/ModalError'
import './QuizPage.css'
import PresentationalQuizPage from '../../components/pages/PresentationalQuizPage'

const END_TIME_KEY = 'sp_quiz_end_time'

class QuizPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      time: null,
      isWatchingFirestore: false
    }
  }

  componentDidMount() {
    this.props.fetchQuestion()
  }

  render() {
    const {
      type,
      index,
      phase,
      name,
      presentationRank,
      participantCount,
      project,
      recieveChangeStatus,
      recieveChangeParticipant,
      title,
      answerChoiceId,
      question,
      questions,
      isShowModalError,
      popupErrorMessage,
      isAnswerSending,
      answerCount,
      postAnswer
    } = this.props

    if (isShowModalError) {
      return <ModalError />
    }

    if (!project.id) {
      return (
        <div styleName="spinner">
          <Spinner />
        </div>
      )
    }

    if (!this.state.isWatchingFirestore) {
      const firestoreRepository = new FirestoreRepository()
      firestoreRepository.watchPresentationQuizStatus(project.room_id, data => {
        recieveChangeStatus(data)
      })
      firestoreRepository.watchPresentationParticipant(project.room_id, () => {
        recieveChangeParticipant()
      })
      this.setState({
        isWatchingFirestore: true
      })
    }

    // 次回開始時に1位として最初から表示されないように初期化
    if (type !== QuizType.RANKING.value) {
      removeStorage(RANK)
    }

    if (type === QuizType.RANKING.value && name === getStorage(NAME)) {
      // rankをセット
      setStorage(RANK, presentationRank)
    } else {
      // phaseによって出すcontentsを変更
      switch (phase) {
        case QuizPhase.START:
          if (!getStorage(END_TIME_KEY)) {
            setStorage(END_TIME_KEY, Date.now() / 1000 + (question ? question.limit_time : 0))
          }
          this.timeout = setTimeout(() => {
            this.setState({ time: getStorage(END_TIME_KEY) - Date.now() / 1000 })
          }, 0.2 * 1000)
          break
        case QuizPhase.QUESTION:
          clearTimeout(this.timeout)
          removeStorage(END_TIME_KEY)
          this.timeout = null
          this.setState({ time: null })
          break
        default:
          clearTimeout(this.timeout)
          removeStorage(END_TIME_KEY)
          this.timeout = null
          this.setState({ time: null })
          break
      }
    }

    return (
      <React.Fragment>
        <PresentationalQuizPage
          index={index}
          phase={phase}
          type={type}
          name={name}
          time={this.state.time}
          resultName={getStorage(NAME)}
          resultRank={getStorage(RANK)}
          presentationRank={presentationRank}
          participantCount={participantCount}
          answerChoiceId={answerChoiceId}
          question={question}
          questions={questions}
          popupErrorMessage={popupErrorMessage}
          isAnswerSending={isAnswerSending}
          title={title}
          answerCount={answerCount}
          postAnswer={postAnswer}
        />
      </React.Fragment>
    )
  }
}

QuizPage.propTypes = {
  // Socket
  index: PropTypes.number.isRequired,
  phase: PropTypes.number,
  type: PropTypes.number.isRequired,
  name: PropTypes.string,
  presentationRank: PropTypes.number,
  participantCount: PropTypes.number,
  answerChoiceId: PropTypes.number,
  question: PropTypes.object,
  questions: PropTypes.array,
  isShowModalError: PropTypes.bool.isRequired,
  popupErrorMessage: PropTypes.string,
  isAnswerSending: PropTypes.bool.isRequired,
  answerCount: PropTypes.object,
  // API
  project: PropTypes.object,
  title: PropTypes.string,
  // dispatch
  recieveChangeStatus: PropTypes.func.isRequired,
  recieveChangeParticipant: PropTypes.func.isRequired,
  fetchQuestion: PropTypes.func.isRequired,
  postAnswer: PropTypes.func.isRequired
}

const mapStateToProps = state => {
  return {
    phase: state.questions.phase,
    index: state.questions.index,
    type: state.questions.type,
    name: state.questions.name,
    presentationRank: state.questions.presentationRank,
    project: state.questions.project,
    title: state.questions.project.title,
    participantCount: state.questions.participantCount,
    answerChoiceId: state.questions.answer,
    question: state.questions.project.questions[state.questions.index],
    questions: state.questions.project.questions,
    isShowModalError: state.notice.isShowModalError,
    isAnswerSending: state.questions.isAnswerSending,
    popupErrorMessage: state.notice.popupErrorMessage,
    answerCount: state.questions.answerCount
  }
}

const mapDispatchToProps = dispatch => ({
  fetchQuestion: () => dispatch(FETCH_QUESTION()),
  recieveChangeStatus: status => dispatch(RECEIVE_CHANGE_STATUS(status)),
  recieveChangeParticipant: () => dispatch(RECEIVE_CHANGE_PARTICIPANT()),
  postAnswer: data => dispatch(POST_ANSWER(data))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuizPage)
